import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { searchActions, searchFeature } from '../../../store/search.store';
import { takeUntil } from 'rxjs';
import { Base } from '../../wrapper/base-wrapper.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { SiteWideVarsService } from '../../../services/site.wide.vars.service';

@Component({
  selector: 'msh-listing-search',
  imports: [FormsModule, MatIconModule],
  template: `
<div class="flex w-full relative flex-col mt-3 text-navy">
  <mat-icon class=" opacity-50 absolute top-6 left-2">search</mat-icon>
  <input (keyup)="onSearchKeyUp($event)" type="text" placeholder="Search" [(ngModel)]="vars.searchWord" class=" w-full min-w-60 !px-9" />
  <mat-icon (click)="applySearch()" [class]="(!vars.searchWord ? 'opacity-50' : ' cursor-pointer ') + ' absolute top-6 right-2 text-navy'">
    @if(vars.searchWord && vars.searchApplied === vars.searchWord){
      cancel
    }@else {
      arrow_circle_right
    }
  </mat-icon>
</div>
  `,
  styles: ``
})
export class ListingSearchComponent extends Base<ListingSearchComponent> {


  constructor(
    private store:Store,
    public vars: SiteWideVarsService,
    private router: Router,
    // TODO hide header login: Load routing and hide login button when you are on the login page
    // BUG but it is a cute one, and I will keep it for now
  ) {
    super();
    this.store.select(searchFeature.selectParams).pipe(takeUntil(this.$destroy)).subscribe(params=>{
      if(params.contains && this.vars.searchApplied !== params.contains){
        this.vars.searchApplied = this.vars.searchWord = params.contains;
      }
    })
  }
  onSearchKeyUp(ev: KeyboardEvent){
    console.log({code: ev.code})
    if(ev.code == 'Enter' && this.vars.searchWord !== this.vars.searchApplied) this.applySearch();
  }

  applySearch(){
    this.router.navigate(['listing','search'])
    if(this.vars.searchWord === this.vars.searchApplied) this.vars.searchWord = this.vars.searchApplied = '';
    this.store.dispatch(searchActions.contains(this.vars.searchWord))
    this.vars.searchApplied = this.vars.searchWord;
  }
}
